<ng-container *transloco="let t;">
@if (hasModal) {
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Modal header title add Signature (Signing page - section) - Add Signature")}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModalAndClearSignature()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
}
<div class="container signature-container" [ngClass]="{'modal-body p-0': hasModal}">
    <div class="row px-1">
        <div class="col-lg-12 col-12">
            <ul ngbNav #navJustified="ngbNav" class="nav-tabs" (navChange)="changeSignatureType($event)">
                <li ngbNavItem="draw">
                    <a ngbNavLink>{{t("Modal tab title draw signature (Signing page - section) - Draw signature")}}</a>
                    <ng-template ngbNavContent>
                        <div class="signature-header-text">
                            <span>{{roleDetail.recipient.firstname}} {{roleDetail.recipient?.lastname ?? ''}}</span>
                            <span>{{ currectDate | dateFormat | async }}</span>
                        </div>
                        <div class="signature-canvas-box">
                            <div class="signature-color-picker">
                                <div *ngFor="let color of penColors; let i = index" class="signature-color-{{color.colorname}}" [ngClass]="{'active-signature-color': i === penColorIndex}" (click)="changeColor(color,i)"></div>
                            </div>
                            <canvas #regular_signaturepad id="regular_signaturepad" width="100%" height=270></canvas>
                            <span class="clear-signature" (click)="clearSignature()">{{t("Clear signature text (My signature - section) - Clear")}}</span>
                        </div>
                    </ng-template>
                </li>
                <li ngbNavItem ngbNavItem="type" *ngIf="roleDetail?.company?.signature_type === 1">
                    <a ngbNavLink>{{t("Modal tab title type signature (Signing page - section) - Type signature")}}</a>
                    <ng-template ngbNavContent>
                        <div class="signature-header-text">
                            <span>{{roleDetail.recipient.firstname}} {{roleDetail.recipient?.lastname ?? ''}}</span>
                            <span>{{currectDate|date:'MMM d y'}}</span>
                        </div>

                        <div class="signature-canvas-box">
                            <div class="signature-color-picker">
                                <div *ngFor="let color of penColors; let i = index" class="signature-color-{{color.colorname}}" [ngClass]="{'active-signature-color': i === penColorIndex}" (click)="changeColor(color,i)"></div>
                            </div>
                            <input [(ngModel)]="signatureValue" [ngModelOptions]="{ standalone: true }" [style.color]="penColor" [style.fontFamily]="fontFamily" [style.fontSize.px]="selectedSignatureFontSize" type="text" class="signature-type-box" [placeholder]='t("Type your signature (My signature - section) - Type your signature")' autofocus>
                            <canvas id="CustomSignCanvas" style="border:1px solid #d3d3d3; width: 100%;visibility: hidden;">Your mobile does not support the canvas element.</canvas>
                            <button type="button" class="btn btn-success signatureTypeBtn" (click)="changeNextFont()">{{t("Next signature font (My signature - section) - Next font")}}</button>
                        </div>
                    </ng-template>
                </li>
                <li ngbNavItem ngbNavItem="upload" [hidden]="true">
                    <a ngbNavLink>{{t("Modal tab title upload signature (Signing page - section) - Upload signature")}}</a>
                    <ng-template ngbNavContent>
                        <div class="signature-header-text">
                            <span>{{roleDetail.recipient.firstname}} {{roleDetail.recipient?.lastname ?? ''}}</span>
                            <span>{{currectDate|date:'MMM d y'}}</span>
                        </div>

                        <div class="signature-canvas-box uplaodSignature-canvas-box">
                            <button type="button" class="btn btn-success uploadSignatureBtn">{{t("Upload your signature text (My signature - section) - Upload your signature")}}</button>
                        </div>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="navJustified" class="mt-75"></div>
        </div>
    </div>
</div>

@if (hasModal) {
    <div class="modal-footer">
        <button [disabled]="signatureloader" type="button" class="btn btn-primary" rippleEffect (click)="addSignature()">
            {{t("Save button text (save button) - save")}} <span *ngIf="signatureloader" class="spinner-border spinner-border-sm me-1"></span>
        </button>
    </div>
}
</ng-container>